/*
  Shop the look (sections/mm-shop-the-look.liquid): size choices for pieces that have them.

  The adds themselves are done by assets/mm-cart-pairs.js ([data-mm-pair-add] and [data-mm-set-add]).
  This script keeps those attributes in step with the chosen sizes, keeps the look total right, and stops
  an add (before mm-cart-pairs.js sees the click) when a size is still missing, pointing at the select.
*/
(function () {
  if (window.mmShopLookReady) return;
  window.mmShopLookReady = true;

  function words(root) {
    var block = root.querySelector('[data-mm-i18n]');
    try { return JSON.parse(block.textContent) || {}; } catch (e) { return {}; }
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '₹' + Math.round(cents / 100);
    }
  }

  function refresh(root) {
    var ids = [];
    var total = 0;
    var missing = false;
    root.querySelectorAll('[data-mm-look-item]').forEach(function (item) {
      var select = item.querySelector('[data-mm-look-variant]');
      var button = item.querySelector('[data-mm-pair-add]');
      var price = Number(item.dataset.price) || 0;
      if (select) {
        var opt = select.options[select.selectedIndex];
        if (select.value) {
          button.setAttribute('data-mm-pair-add', select.value);
          ids.push(select.value);
          price = Number(opt.dataset.price) || price;
        } else {
          button.setAttribute('data-mm-pair-add', '');
          missing = true;
        }
      } else if (button && button.dataset.mmPairAdd) {
        ids.push(button.dataset.mmPairAdd);
      }
      total += price;
    });
    var all = root.querySelector('[data-mm-set-add]');
    if (all) {
      all.setAttribute('data-mm-set-add', ids.join(','));
      all.toggleAttribute('data-mm-look-needs', missing);
    }
    var totalEl = root.querySelector('[data-mm-look-total]');
    if (totalEl && total > 0) {
      /* Keep the store's own money format when the total has not moved. */
      totalEl.textContent = total === Number(totalEl.dataset.cents) ? totalEl.dataset.text : money(total);
    }
  }

  function ask(root, select) {
    var msg = root.querySelector('[data-mm-pairs-msg]');
    var text = words(root).choose_first;
    if (typeof text !== 'string' || !text || text.indexOf('translation missing') !== -1) text = 'Choose a [option] for [title] first.';
    if (msg) msg.textContent = text.replace('[option]', select.dataset.option || 'size').replace('[title]', select.dataset.title || '');
    select.classList.add('is-missing');
    select.focus();
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-mm-look-variant]');
    if (!select) return;
    var root = select.closest('[data-mm-look]');
    select.classList.remove('is-missing');
    var msg = root.querySelector('[data-mm-pairs-msg]');
    if (msg) msg.textContent = '';
    refresh(root);
  });

  /* Runs on the look itself, so it comes before mm-cart-pairs.js, which listens on the document. */
  function guard(event) {
    var root = event.currentTarget;
    var one = event.target.closest('[data-mm-pair-add]');
    var all = event.target.closest('[data-mm-set-add]');
    if (one && !one.dataset.mmPairAdd) {
      var sel = one.closest('[data-mm-look-item]').querySelector('[data-mm-look-variant]');
      event.preventDefault();
      event.stopPropagation();
      if (sel) ask(root, sel);
      return;
    }
    if (all && all.hasAttribute('data-mm-look-needs')) {
      var first = Array.prototype.find.call(root.querySelectorAll('[data-mm-look-variant]'), function (s) { return !s.value; });
      event.preventDefault();
      event.stopPropagation();
      if (first) ask(root, first);
    }
  }

  function init() {
    document.querySelectorAll('[data-mm-look]').forEach(function (root) {
      if (root.dataset.mmLookReady) return;
      root.dataset.mmLookReady = '1';
      root.addEventListener('click', guard);
      refresh(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
